import { useInitActionCombo } from '../../../commons/combobox/initActionCombo.js';
import { useRemoteCombobox } from '@/setup/remoteCombobox.js';
import { reactive, getCurrentInstance, ref, computed } from 'vue';
export const useBUPlanWithdrawDetailDataCommon = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData, submitQuickAdd } = useRemoteCombobox();

  // Tạo object lưu dữ liệu các field
  const comboboxDataRemote = reactive({
    budget_source_name: [],
    budget_chapter_code: [],
    budget_sub_kind_item_code: [],
    budget_item_code: [],
    project_code: [],
    bank_account: [],
    activity_name: [],
    statistic_code: [],
    debit_account: [],
    credit_account: [],
    accounting_object_code: [],
    state_bank: [],
  });

  /**
   * Biến dùng để disabled Sinh chứng từ chuyển khoản KB vào TK tiền gửi
   * NXCHIEN 26.04.2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled Sinh chứng từ ngược lại
   * NXCHIEN 26.04.2022
   */
  const genData = computed(() => {
    return proxy._formParam?.data?.IsGenerateData || proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  // item của button tiện ích
  const buttonUtilities = reactive([
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      subItem: [
        {
          text: 'Rút dự toán tiền mặt',
          command: 'ShowWithDrawCash',
        },
        {
          text: 'Rút dự toán tiền gửi',
          command: 'ShowWithDrawDeposit',
        },
        {
          text: 'Rút dự toán chuyển khoản',
          command: 'ShowWithDrawTransfer',
        },
        {
          text: 'Rút dự toán chuyển khoản lương, bảo hiểm',
          command: 'ShowWithDrawSalaryTransfer',
        },
      ],
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      subItem: [
        {
          text: 'Rút dự toán tiền mặt',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawCashDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawCash
        },
        {
          text: 'Rút dự toán tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawDepositDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
          initial: true
        },
        {
          text: 'Rút dự toán chuyển khoản',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawTransferDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawTransfer
        },
        {
          text: 'Rút dự toán chuyển khoản lương, bảo hiểm',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawSalaryTransferDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer
        },
      ]
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   disabledItem: valueMode,
    // },
    {
      text: 'Sinh chứng từ Chuyển khoản KB vào TK tiền gửi',
      command: 'ShowTransfer',
      disabledItem: genData,
    },
  ]);

  // item button in
  const buttonPrints = [
    { text: 'Chứng từ kế toán' },
    {
      text: 'Tùy chọn in',
    },
  ];

  const toggleAbove = ref(true);

  const toggleAboveHandler = () => {
    toggleAbove.value = !toggleAbove.value;
  };

  //#region khởi tạo config cho combox trong grid
  const {
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetDetailItemComboConfig,
    budgetKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    accountComboConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    accountComboConfig2,
    contractComboConfig,
    TaskComboConfig,
    topicComboConfig,
    budgetProvideComboConfig,
    fundStructureComboConfig,
    typeOfFundComboConfig,
    accountComboMostDetailConfig,
    accountComboParalellConfig,
  } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);
  //#endregion

  return {
    buttonUtilities,
    buttonPrints,
    toggleAbove,
    toggleAboveHandler,
    comboboxDataRemote,

    // config các field của grid ở dạng combo
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetDetailItemComboConfig,
    budgetKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    accountComboConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    accountComboMostDetailConfig,
    accountComboParalellConfig,
    accountComboConfig2,
    contractComboConfig,
    topicComboConfig,
    TaskComboConfig,
    budgetProvideComboConfig,
    fundStructureComboConfig,
    typeOfFundComboConfig,
    // func combo
    submitQuickAdd,
    comboboxLoadData,
    valueMode,
  };
};
